import { Image } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import texts from '@components/OpportunityListing/components/en.json';

const ViewOtherOpportunitiesButton = ({
    buttonType,
    buttonSize,
    className,
    showActiveOpportunities,
    openOtherOpportunitiesPage,
}) => (
    <Button
        buttonSize={buttonSize}
        buttonType={buttonType}
        buttonText={
            showActiveOpportunities
                ? texts.ViewRecentlyClosed
                : texts.ViewActiveOpportunities
        }
        onClick={openOtherOpportunitiesPage}
        suffixComponent={
            <Image src="/images/profile/Arrow-right-white.svg" alt="arrow" />
        }
        type="button"
        className={className}
    />
);

export default ViewOtherOpportunitiesButton;
